module.exports = ".full-width {\r\n  width: 100%\r\n}\r\n"